import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-unassigned-drivers",
  templateUrl: "./unassigned-drivers.component.html",
  styleUrls: ["./unassigned-drivers.component.css"],
})
export class UnassignedDriversComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
